<template>
  <div class="flex flex-col items-center justify-center py-20">
    <div class="w-10 h-10 border-4 border-border border-t-primary rounded-full animate-spin"></div>
    <p class="mt-4 text-muted-foreground">加载中...</p>
  </div>
</template>
